import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { LocalStorageService, SessionStorageService } from "ngx-webstorage";
import { environment } from "../../../environments/environment";
import { Login } from "../login/login.model";

interface JwtToken {
  id_token: string;
}

export const TOKEN_STORAGE = "authenticationToken";

@Injectable({ providedIn: "root" })
export class AuthServerProvider {
  constructor(
    private http: HttpClient,
    private $localStorage: LocalStorageService,
    private $sessionStorage: SessionStorageService
  ) {}

  getToken(): string {
    return (
      this.$localStorage.retrieve(TOKEN_STORAGE) ||
      this.$sessionStorage.retrieve(TOKEN_STORAGE) ||
      ""
    );
  }

  setToken(token: string): void {
    this.$sessionStorage.store(TOKEN_STORAGE, token);
  }

  login(credentials: Login): Observable<void> {
    return this.http
      .post<JwtToken>(environment.apiURL + "login/authenticate", credentials)
      .pipe(map((response) => this.authenticateSuccess(response)));
  }

  loginClave(token: JwtToken): void {
    this.authenticateSuccess(token);
  }

  logout(): Observable<void> {
    return new Observable((observer) => {
      this.$localStorage.clear(TOKEN_STORAGE);
      this.$sessionStorage.clear(TOKEN_STORAGE);
      observer.complete();
    });
  }

  anonymous(appId: string): Observable<void> {
    return this.http
      .post<JwtToken>(environment.apiURL + "login/anonymous", appId)
      .pipe(map((response) => this.authenticateSuccess(response)));
  }

  private authenticateSuccess(response: JwtToken): void {
    const jwt = response.id_token;
    this.$sessionStorage.store(TOKEN_STORAGE, jwt);
  }
}
